import ko from "./tables/strings/ko.json";

export type StringTable = Record<string, string>;

const tables: Record<string, StringTable> = {
  ko: ko as StringTable,
};

let locale = "ko";

export function setLocale(next: string): void {
  if (!tables[next]) throw new Error(`[strings] unknown locale: ${next}`);
  locale = next;
}

/** Lookup UI copy by key. Missing keys fail loudly (no silent fallback to English). */
export function t(key: string, vars?: Record<string, string | number>): string {
  const table = tables[locale];
  const template = table[key];
  if (template === undefined) {
    throw new Error(`[strings] missing key "${key}" in locale "${locale}"`);
  }
  if (!vars) return template;
  return template.replace(/\{(\w+)\}/g, (_, name: string) =>
    String(vars[name] ?? `{${name}}`),
  );
}

export function hasString(key: string): boolean {
  return tables[locale][key] !== undefined;
}
